"use client"
import type { IQACategory } from "src/lib/types/QuestionAndAnswer";
import styles from "./QACategory.module.css";
import QAQuestion from "src/components/questionsandanswer/QAQuestion";

type QACategoryProps = {
    category: IQACategory;
}

export default function QACategory({ category }: QACategoryProps) {
    if (!category?.questions || category.questions.length === 0) {
        return null;
    }
    return <div className={styles.SQACategory}>
        <h2 className={styles.SQACTitle}>{category.categoryName}</h2>
        {category.questions.map(q => <QAQuestion key={q._key} question={q} />)}
    </div>;
}
